export const COUNTRY_NAME_CANADA = 'Canada';
export const COUNTRY_NAME_US = 'United States';
export const PAYMENT_PROVIDER_NAME_STRIPE = 'stripe';
export const PAYMENT_PROVIDER_NAME_WEPAY = 'wepay';
